'use client'
import {createContext} from "react";
import {HttpConcern} from "@web-libs/core/http/infrastructure/client-side/use-http.concern";
import {useContextStrict} from "@web-libs/core/context/context.functions";

export const HttpContext = createContext<HttpConcern|null>(null)

export const useHttpContext = () => useContextStrict(HttpContext)

